import { TypeOf, yup } from '@guiker/yup-util'

export const requestPdfLinkPayloadValidator = yup.object({
  applicantId: yup.string().required(),
})

export type RequestPdfLinkPayloadValidator = TypeOf<typeof requestPdfLinkPayloadValidator>
